/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmAddressTokenTrxListRequest = {
    tokenType: EvmAddressTokenTrxListRequest.tokenType;
    address: string;
    page?: number;
    size?: number;
};

export namespace EvmAddressTokenTrxListRequest {

    export enum tokenType {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

